<script setup lang="ts">
import { onMounted } from "vue";
import { funnelService } from "@/services/funnelService.ts";

onMounted(() => {
  funnelService.trackEvent("web_page_view");
});
</script>
